import { render, staticRenderFns } from "./SelectorLocaleFlag.vue?vue&type=template&id=1641de94&scoped=true&"
import script from "./SelectorLocaleFlag.vue?vue&type=script&lang=js&"
export * from "./SelectorLocaleFlag.vue?vue&type=script&lang=js&"
import style0 from "./SelectorLocaleFlag.vue?vue&type=style&index=0&id=1641de94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1641de94",
  null
  
)

export default component.exports